 // document.querySelectorAll('.cl-legal-accordion--header').forEach(header => {
 //    header.addEventListener('click', () => {
 //      const item = header.closest('.cl-legal-accordion--item');
 //      const content = item.querySelector('.cl-legal-accordion--content');
 //      const isActive = item.classList.contains('active');

 //      // Close all
 //      document.querySelectorAll('.cl-legal-accordion--item.active').forEach(activeItem => {
 //        if (activeItem !== item) {
 //          const activeContent = activeItem.querySelector('.cl-legal-accordion--content');
 //          activeContent.style.height = '0px';
 //          activeItem.classList.remove('active');
 //        }
 //      });

 //      if (!isActive) {
 //        item.classList.add('active');
 //        content.style.height = content.scrollHeight + 'px';
 //      } else {
 //        content.style.height = '0px';
 //        item.classList.remove('active');
 //      }
 //    });
 //  });

 //  // Reset height for already active on load (if any)
 //  window.addEventListener('load', () => {
 //    document.querySelectorAll('.cl-legal-accordion--item.active .cl-legal-accordion--content').forEach(content => {
 //      content.style.height = content.scrollHeight + 'px';
 //    });
 //  });
// $(document).ready(function(){
//   $('.cl-legal-accordion--header').on('click', function(){
//     $('.cl-legal-accordion--content').not($(this).siblings('.cl-legal-accordion--content')).slideUp();
//     $('.cl-legal-accordion--icon').not($(this).find('.cl-legal-accordion--icon')).removeClass('rotated');
//     $(this).siblings('.cl-legal-accordion--content').slideToggle();
//     $(this).find('.cl-legal-accordion--icon').toggleClass('rotated');
//   });
// });
$(document).ready(function(){
  $('.cl-legal-accordion--header').on('click', function(){
    $('.cl-legal-accordion--content').not($(this).siblings('.cl-legal-accordion--content')).slideUp();
    $('.cl-legal-accordion--icon').not($(this).find('.cl-legal-accordion--icon')).removeClass('rotated');
    $(this).siblings('.cl-legal-accordion--content').slideToggle();
    $(this).find('.cl-legal-accordion--icon').toggleClass('rotated');
  });

  $('.cl-legal-accordion--content').first().slideDown();
  $('.cl-legal-accordion--header').first().find('.cl-legal-accordion--icon').addClass('rotated');
});


